const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';

export const getPosts = () => ({
    type: 'INITIATED_GET_POSTS',
    meta: {
        fetch: {
            url: `${API_URL}/api/posts`,
            settings: {
                method: 'GET',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
            },
            actions: {
                success: 'GET_POSTS_SUCCESS',
                error: 'GET_POSTS_ERROR',
            },
        },
    },
});

export const createPost = data => ({
    type: 'INITIATED_CREATE_POST',
    meta: {
        fetch: {
            url: `${API_URL}/api/posts`,
            settings: {
                method: 'POST',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
                body: JSON.stringify(data),
            },
            actions: {
                success: getPosts,
                error: 'CREATE_POST_ERROR',
            },
        },
    },
});

export const likePost = postId => ({
    type: 'INITIATED_LIKE_POST',
    meta: {
        fetch: {
            url: `${API_URL}/api/posts/${postId}/like`,
            settings: {
                method: 'POST',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
            },
            actions: {
                success: getPosts,
                error: 'LIKE_POST_ERROR',
            },
        },
    },
});

export const removePostLike = (postId, likeId) => ({
    type: 'INITIATED_REMOVE_LIKE_POST',
    meta: {
        fetch: {
            url: `${API_URL}/api/posts/${postId}/remove-like/${likeId}`,
            settings: {
                method: 'POST',
                headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
            },
            actions: {
                success: getPosts,
                error: 'REMOVE_LIKE_POST_ERROR',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/actions/posts.js